import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, defer, NEVER } from 'rxjs';
import { finalize, share } from 'rxjs/operators';
import { LoaderComponent } from 'src/app/loader/loader.component';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private overlayRef?: OverlayRef;
  isLoading = new BehaviorSubject<boolean>(false);
  private loaderTextSubject = new BehaviorSubject<string>('Loading...');
  private isloaderVisibleSubject = new BehaviorSubject<boolean>(true);
  public readonly loaderText$ = this.loaderTextSubject.asObservable();
  public readonly isLoaderVisible$ = this.isloaderVisibleSubject.asObservable();

  constructor(private injector: Injector) { }

  public show(): void {
    this.isLoading.next(true);
    const overlay = this.injector.get(Overlay);

    if (!this.overlayRef) {
      this.overlayRef = overlay.create({
        positionStrategy: overlay.position().global().centerHorizontally().centerVertically(),
        hasBackdrop: false,
      });
    }

    if (!this.overlayRef.hasAttached()) {
      this.overlayRef.attach(new ComponentPortal(LoaderComponent));
    }
  }

  public readonly spinner$ = defer(() => {
    this.show();
    return NEVER.pipe(finalize(() => this.hide()));
  }).pipe(share());

  public hide(): void {
    this.isLoading.next(false);
    if (this.overlayRef?.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  public getLoaderText(): string {
    return this.loaderTextSubject.value;
  }

  public isLoaderVisible(): boolean {
    return this.isloaderVisibleSubject.value;
  }

  public setLoaderText(loaderText: string, isloaderVisible: boolean = true): void {
    this.loaderTextSubject.next(loaderText || 'Loading...');
    this.isloaderVisibleSubject.next(isloaderVisible);
  }

}
